export default "__VITE_ASSET__CBPzjrzC__"